import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";

export const ActionLabel = ({
  icon,
  label,
  iconClassName = "text-content-200"
}: {
  icon: IconSvgElement;
  label: string;
  iconClassName?: string;
}) => (
  <span className="flex gap-3 py-0.5 items-center">
    <HugeiconsIcon icon={icon} size={20} className={iconClassName} />
    <span>{label}</span>
  </span>
);
